import React, { useContext } from "react";
import { Image, Row, Col, Button, NavDropdown } from "react-bootstrap";
import { Cart4, CartFill, PersonCircle } from "react-bootstrap-icons";
import PizzaIcon from "../assets/images/pizza.png";
import { StateContext } from "../contexts/StateContext";
import LoginModal from "./Login/LoginModal";
import { signout } from "../api/api-auth";

const Header = () => {
  const {
    cart,
    user,
    setUser,
    showLoginModal,
    setShowLoginModal,
    setShowOrder,
    setShowOrderHistory,
  } = useContext(StateContext);

  const signoutHandler = async () => {
    await signout();
    setUser(null);
    setShowOrder(false);
  };

  return (
    <>
      <Row>
        <Col className="col-1 d-sm-none d-md-inline"></Col>
        <Col className="col-5">
          <Image src={PizzaIcon} style={{ height: "30px" }} className="m-3" />
          <span className="fs-4 text-primary">Pizza Order </span>
          <span className="fs-4 text-primary d-none d-md-inline">Composer</span>
        </Col>
        <Col className="col-5 m-auto">
          {user ? (
            <NavDropdown
              className="float-end me-2 ms-1 mt-1"
              title={<PersonCircle size={30} />}
            >
              <NavDropdown.Item onClick={() => setShowOrderHistory(true)}>
                Order history
              </NavDropdown.Item>
              <NavDropdown.Item onClick={signoutHandler}>
                Log out
              </NavDropdown.Item>
            </NavDropdown>
          ) : (
            <Button
              variant="outline-primary"
              className="float-end me-2 ms-1 mt-0"
              onClick={() => {
                setShowLoginModal(true);
              }}
            >
              Sign in
            </Button>
          )}
          <span
            className="ml-3 float-end"
            onClick={() => {
              setShowLoginModal(false);
              setShowOrder(false);
              setShowOrderHistory(false);
            }}
          >
            {!!cart.items.length ? (
              <CartFill color="royalblue" size={32} />
            ) : (
              <Cart4 color="royalblue" size={32} />
            )}
            <span className="text-success fs-5 m-1">
              <sup>{cart.items.length}</sup>
            </span>
          </span>
        </Col>
        <Col className="col-1 d-sm-none d-md-inline"></Col>
        <Col className="col-12 mb-2">
          <hr width="90%" className="m-auto" />
        </Col>
      </Row>
      <LoginModal
        showLoginModal={showLoginModal}
        setShowLoginModal={setShowLoginModal}
      />
    </>
  );
};

export default Header;
